module.exports = __webpack_public_path__ + "img/E_1_correct.24dd4caa.png";